import { generateItems } from 'domain/common';
import { Artwork } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Considetation', Artwork);

export { actions, selectors, reducer };
